import { Link } from 'react-router-dom'
import { usePublicCases } from '../hooks/useCases'

export default function CasesSection() {
  const { cases, loading } = usePublicCases(3)

  const fallback = [
    { id: 'demo-1', slug: 'iguatu360', sector: 'public', sub_sector: '', title: 'Iguatu360 — Plataforma de Gestão Municipal Integrada', client: 'Prefeitura Municipal de Iguatu · CE', description: 'Uma plataforma que conecta secretarias, obras, ações e metas em um único ambiente...', featured_result: '🏛️ Gestão municipal unificada em tempo real', tags: ['Web','BI','Obras','Indicadores'] },
    { id: 'demo-2', slug: 'plataforma-aee', sector: 'public', sub_sector: 'Educação', title: 'Plataforma AEE — Atendimento Educacional Especializado', client: 'Rede de Educação Especial Inclusiva', description: 'Do agendamento de sessões ao acompanhamento longitudinal do aluno...', featured_result: '📊 Relatórios automáticos de evolução por aluno', tags: ['Educação Especial','Dashboard','Relatórios'] },
    { id: 'demo-3', slug: 'sistema-avaliacao', sector: 'public', sub_sector: 'Educação', title: 'Sistema de Avaliação de Alunos', client: 'Rede de Ensino Público', description: 'Mais do que registrar notas — o sistema acompanha o desenvolvimento do aluno dia a dia...', featured_result: '🎯 Identificação precisa de lacunas de aprendizado', tags: ['Avaliação','Descritores','Banco de Questões'] },
  ]

  const displayCases = cases.length > 0 ? cases : fallback

  const badgeLabel = (c) => {
    const base = c.sector === 'public' ? 'Setor Público' : 'Setor Privado'
    return c.sub_sector ? `${base} · ${c.sub_sector}` : base
  }
  const badgeClass = (c) => c.sector === 'public' ? 'pub' : 'priv'

  return (
    <section className="section" style={{ background: 'var(--bg-2)' }}>
      <div className="section-inner">
        <div className="cases-header">
          <div>
            <div className="section-eyebrow">Cases de sucesso</div>
            <h2 className="section-title" style={{ marginBottom: 0 }}>Resultados reais que construímos juntos</h2>
          </div>
          <Link to="/cases" className="btn-ghost">Ver todos os cases</Link>
        </div>

        <div className="cases-grid">
          {displayCases.map((c) => (
            <Link to={`/cases/${c.slug}`} key={c.id} style={{ textDecoration: 'none' }}>
              <div className="case-card">
                <span className={`case-sector-badge ${badgeClass(c)}`}>{badgeLabel(c)}</span>
                <h3>{c.title}</h3>
                <p className="case-client">{c.client}</p>
                <p className="case-desc">{c.description}</p>
                <div className="case-result">{c.featured_result}</div>
                <div className="case-tags">
                  {(c.tags || []).map((t) => <span className="case-tag" key={t}>{t}</span>)}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  )
}
